import { all } from "@redux-saga/core/effects";

import { credentialsSagas } from "./Credentials/sagas";
import { credentialsTypesSagas } from "./CredentialsTypes/sagas";

export function* credentialsManagerSaga() {
    yield all([
        credentialsSagas(),
        credentialsTypesSagas(),
    ]);
}
